import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import { IState } from "@/apps/credit-line/models/IState";
import { Module } from "vuex";
import { IVuexState } from "@/shared-models/IVuex";
import { TransactionViewState } from "@/apps/credit-line/types/TransactionViewState";

const creditLineModule: Module<IState, IVuexState> = {
  namespaced: true,
  state: {
    currency: null,
    paymentSchedule: null,
    pendingWithdraw: null,
    withdrawals: null,
    offer: null,
    offer_unavailable: null,
    transactionsFilters: null,
    transactionList: null,
    summary: null,
    selectedWithdrawMethod: null,
    withdrawalEstimate: null,
    shipmentLogs: [],
    runningActions: {
      createVirtualCreditCard: false,
    },
    reportLostOrDamagedCard: {
      reason: null,
      details: null,
      lastFour: null,
    },
    withdrawalValidation: null,
    amlSurveyData: null,
    curpValidationResult: null,
    validationSuccess: false,
    withdrawalEstimateFields: null,
    currentTransactionViewState: TransactionViewState.LIST,
    selectedTransaction: null,
  } as IState,

  mutations,
  actions,
  getters,
};

export default creditLineModule;
